import { ACTIONS_MATERIAL } from '../_constants/material.constants';

const initialState = {
  byId: {},
};

export function materialReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_MATERIAL.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_MATERIAL.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_MATERIAL.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default materialReducer;
